export const ParentIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M17.596 8.5L4.00012 32.0562H31.1973L17.596 8.5Z"
      fill="#DEE9FC"
      stroke="#2F52EA"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.755 16.0455L17.51 32.0562H36L26.755 16.0455Z"
      fill="#BB94EF"
      stroke="#2F52EA"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9962 28.8239C24.9962 28.8239 26.9592 30.0716 29.0191 28.7863"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3831 25.995C24.6742 25.995 24.9102 25.7591 24.9102 25.468C24.9102 25.1769 24.6742 24.9409 24.3831 24.9409C24.0921 24.9409 23.8561 25.1769 23.8561 25.468C23.8561 25.7591 24.0921 25.995 24.3831 25.995Z"
      fill="#2F52EA"
    />
    <path
      d="M29.6375 25.995C29.9286 25.995 30.1646 25.7591 30.1646 25.468C30.1646 25.1769 29.9286 24.9409 29.6375 24.9409C29.3464 24.9409 29.1105 25.1769 29.1105 25.468C29.1105 25.7591 29.3464 25.995 29.6375 25.995Z"
      fill="#2F52EA"
    />
    <path
      d="M14.5199 26.4791C14.5199 26.4791 17.2359 28.2055 20.0863 26.4253"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6645 22.5692C14.0685 22.5692 14.396 22.2417 14.396 21.8377C14.396 21.4338 14.0685 21.1063 13.6645 21.1063C13.2606 21.1063 12.9331 21.4338 12.9331 21.8377C12.9331 22.2417 13.2606 22.5692 13.6645 22.5692Z"
      fill="#2F52EA"
    />
    <path
      d="M20.936 22.5692C21.34 22.5692 21.6674 22.2417 21.6674 21.8377C21.6674 21.4338 21.34 21.1063 20.936 21.1063C20.5321 21.1063 20.2046 21.4338 20.2046 21.8377C20.2046 22.2417 20.5321 22.5692 20.936 22.5692Z"
      fill="#2F52EA"
    />
  </svg>
);
